import { Signal, computed, signal } from '@angular/core';
import { IPlayerChapter } from './IPlayerChapter';

export class ChapterHelper {
	public readonly chapterPreviewWidth = 192;
	public readonly chapterPreviewHeight = 108;
	public showChapterImage: boolean = false;

	public readonly chapters = signal([] as IPlayerChapter[]);
	public readonly currentChapterIndex = computed(() =>
		this.getChapterIndexByTimeMs(this.getCurrentTime()));
	public readonly isImagePresentInAnyChapter = computed(() => this.chapters().some(chapter => chapter.url));
	public readonly previousChapter = computed(() => this.chapters()[this.currentChapterIndex() - 1]);
	public readonly currentChapter = computed(() => this.chapters()[this.currentChapterIndex()]);
	public readonly nextChapter = computed(() => this.chapters()[this.currentChapterIndex() + 1]);

	constructor(
		public readonly initialChapters: IPlayerChapter[],
		public readonly getCurrentTime: Signal<number>
	) {
		this.setChapters(this.initialChapters);
	}

	public setChapters(chapters: IPlayerChapter[]): void {
		const chaptersCopy = chapters.map((chapter, index) => ({ ...chapter, chapterIndex: index }));

		if (chaptersCopy?.length && chaptersCopy?.[0]?.time !== 0) {
			const fakeInitialChapter: IPlayerChapter = {
				time: 0,
				title: '',
				url: '',
				isFakeInitialChapter: true,
				chapterIndex: -1
			};
			chaptersCopy.unshift(fakeInitialChapter);
		}

		this.chapters.set(chaptersCopy);
	}

	public setShowChapterImage(showChapterImage: boolean): void {
		this.showChapterImage = showChapterImage;
	}

	public getChapterByTimeMs(timeMs: number): IPlayerChapter | null {
		return this.chapters()[this.getChapterIndexByTimeMs(timeMs)];
	}

	private getChapterIndexByTimeMs(timeMs: number): number {
		const chapters = this.chapters();
		for (let i = 0; i < chapters.length - 1; i++) {
			const chapter = chapters[i];
			const nextChapter = chapters[i + 1];
			if (chapter.time <= timeMs && nextChapter.time > timeMs) {
				return i;
			}
		}
		if (chapters.length > 0 && chapters[chapters.length - 1].time <= timeMs) {
			return chapters.length - 1;
		}
	}
}
